<template>
  <div class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-dialog v-model="dialog.success"
          persistent>
          <v-card
            class="border-radius pa-2">
            <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
              <v-avatar size="35">
                <v-img
                  contain
                  width="30"
                  height="30"
                  alt="kominfo"
                  :src="require('@/assets/logo/favicon.png')">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center">
                      <v-progress-circular
                        indeterminate
                        color="#7c0404">
                      </v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-avatar>

              <span class="body-1 font-weight-bold mt-1 ml-1">
                Pengajuan Pengiriman Berhasil
              </span>
            </v-card-title>

            <v-divider class="mx-4 mt-3 mb-2"/>

            <v-card-text class="body-2 font-weight-light text-first line-text-second mt-3">
              Terima kasih, Anda telah mengajukan pengiriman produk Anda di PRASOJO.
            </v-card-text>

            <v-divider class="mx-4 mb-3 mt-0"/>

            <v-card-actions>
              <v-spacer/>

              <v-btn @click="dialog.success = false; sheet.pos = false; fetch();"
                color="red"
                elevation="0"
                class="text-capitalize white--text"
                style="border-radius: 15px; box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px;">
                <v-icon small class="mr-1">mdi-close-thick</v-icon>
                Tutup
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.success_koreksi"
          persistent>
          <v-card
            class="border-radius pa-2">
            <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
              <v-avatar size="35">
                <v-img
                  contain
                  width="30"
                  height="30"
                  alt="kominfo"
                  :src="require('@/assets/logo/favicon.png')">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center">
                      <v-progress-circular
                        indeterminate
                        color="#7c0404">
                      </v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-avatar>

              <span class="body-1 font-weight-bold mt-1 ml-1">
                Koreksi Ajuan Pengiriman Berhasil
              </span>
            </v-card-title>

            <v-divider class="mx-4 mt-3 mb-2"/>

            <v-card-text class="body-2 font-weight-light text-first line-text-second mt-3">
              Terima kasih, Anda telah mengajukan pengiriman produk Anda di PRASOJO.
            </v-card-text>

            <v-divider class="mx-4 mb-3 mt-0"/>

            <v-card-actions>
              <v-spacer/>

              <v-btn @click="dialog.success_koreksi = false; sheet.koreksi = false; sheet.detail =  false; fetchLogPOS();"
                color="red"
                elevation="0"
                class="text-capitalize white--text"
                style="border-radius: 15px; box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px;">
                <v-icon small class="mr-1">mdi-close-thick</v-icon>
                Tutup
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>
          <!-- <v-card v-if="process.pos"
            flat
            class="my-2"
            style="border: 2px dashed #e0e0e0; border-radius: 5px;">
            <v-card-text>
              <v-skeleton-loader
                class="ma-auto"
                :loading="process.load"
                type="article">
              </v-skeleton-loader>
            </v-card-text>
          </v-card> -->

          <!-- <v-card v-if="!process.pos && Object.keys(detail_pos).length > 0"
            flat
            class="my-2"
            style="border: 2px dashed #eaeaea; border-radius: 5px;">
            <v-card-text>
              <div
                class="d-flex align-center">
                <div
                  class="font-weight-bold black--text">
                  #{{ detail_pos.delivery_kode }}
                </div>

                <v-spacer />

                <div
                  class="font-weight-light">
                  {{ detail_pos.delivery_create_datetime | date }}
                </div>
              </div>

              <v-divider
                class="my-3"
                style="border-top: 2px dashed #eaeaea;" />

              <div
                class="font-weight-light">
                <div
                  class="d-flex align-center mb-1">
                  <div>
                    Penerima
                  </div>

                  <v-spacer />

                  <div>
                    {{ detail_pos.delivery_receiver.name }}
                  </div>
                </div>

                <div
                  class="d-flex align-center mb-1">
                  <div>
                    Telepon
                  </div>

                  <v-spacer />

                  <div>
                    {{ detail_pos.delivery_receiver.phone }}
                  </div>
                </div>

                <v-divider
                  class="my-3"
                  style="border-top: 2px dashed #eaeaea;" />

                <div
                  class="d-flex align-center mb-1">
                  <div>
                    Alamat
                  </div>

                  <v-spacer />

                  <div>
                    {{ detail_pos.delivery_receiver.address }}
                  </div>
                </div>

                <div
                  class="d-flex align-center mb-1">
                  <div>
                    Provinsi
                  </div>

                  <v-spacer />

                  <div>
                    {{ detail_pos.delivery_receiver.province }}
                  </div>
                </div>

                <div
                  class="d-flex align-center mb-1">
                  <div>
                    Kabupaten
                  </div>

                  <v-spacer />

                  <div>
                    {{ detail_pos.delivery_receiver.city }}
                  </div>
                </div>

                <div
                  class="d-flex align-center mb-1">
                  <div>
                    Kecamatan
                  </div>

                  <v-spacer />

                  <div>
                    {{ detail_pos.delivery_receiver.subdistrict }}
                  </div>
                </div>

                <div
                  class="d-flex align-center mb-1">
                  <div>
                    Kelurahan
                  </div>

                  <v-spacer />

                  <div>
                    {{ detail_pos.delivery_receiver.village }}
                  </div>
                </div>

                <div
                  class="d-flex align-center">
                  <div>
                    Kode POS
                  </div>

                  <v-spacer />

                  <div>
                    {{ detail_pos.delivery_receiver.zipcode }}
                  </div>
                </div>

                <v-divider
                  class="my-3"
                  style="border-top: 2px dashed #eaeaea;" />

                <div
                  class="d-flex align-center">
                  <div>
                    No. Resi
                  </div>

                  <v-spacer />

                  <div>
                    {{ detail_pos.delivery_resi !== '' ? detail_pos.delivery_resi : '-' }}
                  </div>
                </div>

                <v-divider
                  class="my-3"
                  style="border-top: 2px dashed #eaeaea;" />

                <div
                  class="d-flex align-center">
                  <div>
                    Status Pengiriman
                  </div>

                  <v-spacer />

                  <div>
                    <div
                      @click="sheet.log = true; fetchLogPOS();"

                      class="font-weight-bold d-flex align-center cursor-pointer">
                      <v-icon
                        size="20">
                        mdi-eye-settings
                      </v-icon>

                      <span
                        class="ml-1">
                        Lihat
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card> -->


          <v-card
            flat
            color="transparent">
            <v-list
              flat
              color="transparent"
              three-line>
              <v-list-item-group>
                <v-skeleton-loader
                  v-for="(item, index) in process.load ? 5 : list"
                  :key="index"
                  class="ma-auto"
                  :loading="process.load"
                  type="list-item-avatar-three-line">
                  <template>
                    <div>
                      <v-list-item v-if="!process.load && list.length > 0"
                        class="pl-3 mb-4"
                        style="border-radius: 5px;
                              border: 2px solid #eaeaea;
                              border-style: dashed;
                              background: #fff;
                              cursor: auto;">
                        <v-list-item-avatar
                          tile
                          size="50"
                          class="mr-3">
                          <v-img
                            style="border-radius: 5px;"
                            alt="kominfo"
                            :src="require(`@/assets/image/service/${item.prod_layanan_kode}.png`)"
                            class="ma-auto">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular
                                  indeterminate
                                  color="#7c0404">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-list-item-avatar>

                        <v-list-item-content>
                          <v-list-item-title
                            class="body-2 font-weight-bold d-flex align-center">
                            <span>
                              {{ item.prod_layanan_kode }} - {{ item.prod_nomor }}
                            </span>

                            <v-spacer />

                            <v-btn
                              icon
                              x-small
                              :to="`/product/${item.prod_ajuan_id}?prod_id=${item.prod_id}&code=${item.prod_layanan_kode}`">
                              <v-icon size="20" color="blue">mdi-information</v-icon>
                            </v-btn>
                          </v-list-item-title>

                          <v-list-item-subtitle
                            class="caption font-weight-light black--text my-2"
                            style="opacity: 60%;">
                            <div
                              style="margin-bottom: 7px;">
                              <span
                                class="one-line text-uppercase">
                                {{ item.prod_nama }}
                              </span>
                            </div>

                            <div
                              class="font-weight-bold"
                              :class="item.prod_status === 'BELUM DIVERIFIKASI' || item.prod_status === 'BELUM DIAJUKAN TTE' ? 'orange--text' :
                                      item.prod_status === 'TIDAK DIPROSES' ? 'red--text' : 'cyan--text'">
                              <span
                                class="one-line">
                                {{ item.prod_status }}
                              </span>
                            </div>
                          </v-list-item-subtitle>

                          <v-list-item-subtitle
                            class="caption font-weight-light black--text mb-1"
                            style="opacity: 60%;">
                            <span
                              class="ten-line line-text-first mb-1"
                              v-html="item.prod_status_note.replace(/(<([^>]+)>)/ig, '')">
                            </span>
                          </v-list-item-subtitle>

                          <v-list-item-subtitle
                            class="caption font-weight-light black--text d-flex align-center">
                            <span
                              class="one-line">
                              {{ item.prod_create_datetime | date }}
                            </span>

                            <v-spacer />

                            <span v-if="item.prod_status === 'SIAP DIDOWNLOAD' && item.prod_url.length > 0">
                              <a
                                :href="item.prod_url"
                                target="_blank">
                                <v-icon size="20" color="green">mdi-download</v-icon>
                              </a>
                            </span>

                            <!-- <span v-if="item.prod_status === 'SIAP DIAMBIL' && (item.prod_from_layanan_kode === 'KTP' || item.prod_from_layanan_kode === 'KIA') && Object.keys(detail_pos).length < 1"
                              class="ml-2">
                              <div>
                                <v-icon
                                  @click="sheet.pos = true; reset();"

                                  class="cursor-pointer"
                                  size="20"
                                  color="orange">
                                  mdi-truck-fast
                                </v-icon>
                              </div>
                            </span> -->
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                  </template>
                </v-skeleton-loader>
              </v-list-item-group>
            </v-list>

            <v-card-text v-if="pagination.total_data > 10 && limit < pagination.total_data"
              class="text-center">
              <v-btn
                small
                rounded
                outlined
                elevation="0"
                color="#7c0404"
                class="color-default text-capitalize"
                @click="limit += 10">
                Lihat Lebih Banyak
              </v-btn>
            </v-card-text>

            <Empty v-if="!process.load && pagination.total_data < 1"
              margin="my-10"
              padding="pa-16"
              font="body-2"
              :size="150"
              message="Produk" />
          </v-card>
        </section>

        <!-- REQUEST -->
        <v-bottom-sheet
          v-model="sheet.pos"
          hide-overlay
          persistent
          fullscreen
          scrollable>
          <v-card
            flat
            style="border-radius: 0px;">
            <v-card-title
              @click="sheet.pos = false"
              class="cursor-pointer pa-4"
              style="border-radius: 0px 0px 15px 15px;
                    position: absolute;
                    width: 100%;
                    z-index: 1;
                    background: #7c0404;">
              <v-icon color="white">
                mdi-arrow-left-thick
              </v-icon>

              <span
                class="body-1 font-weight-bold text-capitalize white--text ml-1">
                Pengiriman POS
              </span>
            </v-card-title>

            <v-card
              flat
              color="#7c0404"
              class="pt-12 pb-4"
              style="border-radius: 0px 0px 15px 15px;">
              <v-card-title
                class="white--text pb-1">
                #Pengajuan Pengiriman
              </v-card-title>

              <v-card-text
                class="white--text line-text-second pb-1">
                <v-divider
                  class="mb-3"
                  style="border: 2px solid #fff; border-radius: 50px;" />

                <div>
                  <div>
                    No. Reg: {{ detail.ajuan_no_reg }}
                  </div>

                  <div>
                    Nama Lengkap: {{ detail.ajuan_data_ajuan.field.nama_lengkap }}
                  </div>

                  <div>
                    NIK: {{ detail.ajuan_data_ajuan.field.nik }}
                  </div>

                  <div
                    class="font-weight-bold mt-3">
                    Alamat:
                  </div>

                  <div>
                    Kecamatan: {{ detail.ajuan_kecamatan_name }} ({{ detail.ajuan_kecamatan_code }})
                  </div>

                  <div>
                    Kelurahan: {{ detail.ajuan_kelurahan_name }} ({{ detail.ajuan_kelurahan_code }})
                  </div>
                </div>

                <v-divider
                  class="my-3"
                  style="border: 2px solid #fff; border-radius: 50px;" />

                <div>
                  <div
                    class="caption font-weight-bold d-flex align-center mt-4">
                    <div
                      class="d-flex align-center">
                      <v-icon small color="white" class="mr-1">mdi-calendar-month</v-icon>

                      {{ detail.ajuan_create_datetime | date }}
                    </div>

                    <v-spacer />

                    <div
                      class="d-flex align-center">
                      <v-icon small color="white" class="mr-1">mdi-clock-time-three-outline</v-icon>

                      {{ detail.ajuan_create_datetime | time }}
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>

            <v-card-text
              class="pt-6 pb-2">
              <ValidationObserver
                ref="form">
                <v-form>
                  <div>
                    <div
                      class="font-weight-bold black--text">
                      Kontak & Alamat Pengiriman
                    </div>

                    <div
                      class="mb-4">
                      Sesuaikan kontak & alamat pengiriman di bawah ini :
                    </div>
                  </div>

                  <ValidationProvider
                    name="name"
                    rules="required"
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Nama Penerima
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>

                    <v-text-field
                      filled
                      rounded
                      dense
                      color="#7c0404"
                      placeholder="Contoh. Firmansyah Abdul Rafi"
                      :append-icon="valid ? 'mdi-check-circle-outline' : ''"
                      v-model="form.receiver.name"
                      v-uppercase
                      :success="valid"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider
                    name="phone"
                    rules="required|min:8|max:13"
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Telepon
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>

                    <v-text-field
                      v-on:keyup.enter="save"
                      type="number"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      min="0"
                      filled
                      rounded
                      dense
                      color="#7c0404"
                      placeholder="Contoh. 081332XXXXXX"
                      :append-icon="valid ? 'mdi-check-circle-outline' : ''"
                      v-model="form.receiver.phone"
                      v-uppercase
                      :success="valid"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider
                    name="email"
                    rules="required|email"
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Email
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>

                    <v-text-field
                      v-on:keyup.enter="save"
                      filled
                      rounded
                      dense
                      color="#7c0404"
                      placeholder="Contoh. XXXXX@gmail.com"
                      :append-icon="valid ? 'mdi-check-circle-outline' : ''"
                      v-model="form.receiver.email"
                      :success="valid"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider
                    name="address"
                    rules="required"
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Alamat
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>

                    <v-text-field
                      filled
                      rounded
                      dense
                      color="#7c0404"
                      placeholder="Contoh. Kemiri"
                      :append-icon="valid ? 'mdi-check-circle-outline' : ''"
                      v-model="form.receiver.address"
                      v-uppercase
                      :success="valid"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider
                    name="Provinsi"
                    rules="required"
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Provinsi
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>

                    <v-autocomplete
                      filled
                      rounded
                      dense
                      color="#7c0404"
                      placeholder="Contoh. Jawa tengah"
                      :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                      :items="config.province_pos"
                      item-value="provinceCode"
                      item-text="provinceName"
                      item-color="#7c0404"

                      v-model="form.receiver.provinceCode"
                      :success="valid"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                    </v-autocomplete>
                  </ValidationProvider>

                  <ValidationProvider
                    name="Kabupaten"
                    rules="required"
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Kabupaten
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>

                    <v-autocomplete
                      filled
                      rounded
                      dense
                      color="#7c0404"
                      placeholder="Contoh. Sukoharjo"
                      :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                      :items="config.city_pos"
                      item-value="cityCode"
                      item-text="cityName"
                      item-color="#7c0404"

                      v-model="form.receiver.cityCode"
                      :success="valid"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                    </v-autocomplete>
                  </ValidationProvider>

                  <ValidationProvider
                    name="Kecamatan"
                    rules="required"
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Kecamatan
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>

                    <v-autocomplete
                      filled
                      rounded
                      dense
                      color="#7c0404"
                      placeholder="Contoh. Trucuk"
                      :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                      :items="config.subdistrict_pos"
                      item-value="subDistrictCode"
                      item-text="subDistrictName"
                      item-color="#7c0404"

                      v-model="form.receiver.subDistrictCode"
                      :success="valid"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                    </v-autocomplete>
                  </ValidationProvider>

                  <ValidationProvider
                    name="Kode Pos"
                    rules="required"
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Kode Pos
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>

                    <v-autocomplete
                      filled
                      rounded
                      dense
                      color="#7c0404"
                      placeholder="Contoh. Kradenan (57467)"
                      :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                      :items="config.postal_code"
                      item-value="postalCode"
                      item-text="titlePostalCode"
                      item-color="#7c0404"

                      v-model="form.receiver.zipcode"
                      :success="valid"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                    </v-autocomplete>
                  </ValidationProvider>

                  <v-card v-if="form.receiver.zipcode !== ''"
                    flat
                    color="#ff980033"
                    class="mb-6"
                    style="border: 2px dashed orange; border-radius: 10px;">
                    <v-card-text>
                      <div
                        class="d-flex align-center mb-2">
                        <div>
                          Biaya
                        </div>

                        <v-spacer />

                        <div>
                          {{ form.service.fee | price_2 }}
                        </div>
                      </div>

                      <div
                        class="d-flex align-center mb-2">
                        <div>
                          Pajak Biaya
                        </div>

                        <v-spacer />

                        <div>
                          {{ form.service.feeTax | price_2 }}
                        </div>
                      </div>

                      <div
                        class="d-flex align-center mb-2">
                        <div>
                          Asuransi
                        </div>

                        <v-spacer />

                        <div>
                          {{ form.service.insurance | price_2 }}
                        </div>
                      </div>

                      <div
                        class="d-flex align-center">
                        <div>
                          Pajak Asuransi
                        </div>

                        <v-spacer />

                        <div>
                          {{ form.service.insuranceTax | price_2 }}
                        </div>
                      </div>

                      <v-divider
                        class="my-4"
                        style="border-top: 2px dashed orange;" />

                      <div
                        class="d-flex align-center font-weight-bold black--text">
                        <div>
                          Total
                        </div>

                        <v-spacer />

                        <div>
                          {{ form.service.totalFee | price_2 }}
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>

                  <div>
                    <div
                      class="font-weight-bold black--text mb-2">
                      Upload Data Dukung Pengiriman
                    </div>

                    <div>
                      Jika pengajuan pergantian ktp silahkan upload foto ktp yang sudah di potong dan di lipat seperti contoh di bawah ini :
                    </div>
                  </div>

                  <v-row>
                    <v-col
                      cols="12"
                      md="6">
                      <v-img
                        contain
                        alt="kominfo"
                        :src="require('@/assets/image/KTP_POTONG.jpeg')"
                        style="border-radius: 10px;">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular
                              indeterminate
                              color="#7c0404">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-col>
                  </v-row>

                  <v-card
                    flat
                    color="white"
                    style="box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px; border-radius: 10px;">
                    <v-card-title
                      class="body-2 pb-2 px-0">
                      <span style="opacity: 60%;">
                        Upload Data Dukung
                      </span>
                    </v-card-title>

                    <v-divider
                      style="border: 2px solid #f9f9f9; border-radius: 50px;" />

                    <v-card-text
                      class="py-4 px-0">
                      <v-row>
                        <v-col
                          v-for="(item_img, index_img) in form.receiver.images"
                          :key="index_img"
                          cols="6"
                          md="4">
                          <v-card
                            flat
                            height="136"
                            class="d-flex align-center justify-center"
                            style="border-radius: 15px;
                                  border: 2px solid #eaeaea;
                                  border-style: dashed;
                                  box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px; ">
                            <v-img
                              alt="kominfo"
                              width="100%"
                              height="136"
                              :src="item_img.url"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular
                                    indeterminate
                                    color="#7c0404">
                                  </v-progress-circular>
                                </v-row>
                              </template>

                              <div @click="form.receiver.images.splice(index_img, 1)"
                                class="cursor-pointer"
                                style="position: absolute; top: 5px; right: 5px;">
                                <v-icon size="20" color="red">mdi-close-circle</v-icon>
                              </div>
                            </v-img>
                          </v-card>
                        </v-col>

                        <v-col
                          cols="6"
                          md="4">
                          <v-card @click="sheet.option = true"
                            flat
                            height="136"
                            class="d-flex align-center justify-center"
                            style="border-radius: 15px;
                                  border: 2px solid #eaeaea;
                                  border-style: dashed;">
                            <v-icon v-if="!process.file"
                              size="50"
                              color="grey">
                              mdi-cloud-upload-outline
                            </v-icon>

                            <v-progress-circular v-if="process.file"
                              indeterminate
                              color="#7c0404">
                            </v-progress-circular>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center my-3">
                <v-alert
                  type="error"
                  text
                  dense
                  prominent
                  v-show="message.error.length > 0">
                  {{ message.error }}
                </v-alert>
              </div>
            </v-card-text>

            <v-card-actions
              class="mb-3 pt-0">
              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"

                block
                elevation="0"
                color="orange"
                class="body-2 font-weight-bold white--text text-capitalize d-flex align-center"
                style="border-radius: 10px;">
                <v-icon size="20">mdi-truck-check</v-icon>

                <v-spacer />

                <span
                  class="ml-1">
                  Ajukan Pengiriman
                </span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-bottom-sheet>

        <!-- LOG -->
        <v-bottom-sheet
          v-model="sheet.log"
          hide-overlay
          persistent
          fullscreen
          scrollable>
          <v-card
            flat
            style="border-radius: 0px;">
            <v-card-title
              @click="sheet.log = false; fetchPOS();"
              class="cursor-pointer pa-4"
              style="border-radius: 0px 0px 15px 15px;
                    position: absolute;
                    width: 100%;
                    z-index: 1;
                    background: #7c0404;">
              <v-icon color="white">
                mdi-arrow-left-thick
              </v-icon>

              <span
                class="body-1 font-weight-bold text-capitalize white--text ml-1">
                Log Pengiriman POS
              </span>
            </v-card-title>

            <v-card v-if="Object.keys(detail_pos).length > 0"
              flat
              color="#7c0404"
              class="pt-12 pb-4"
              style="border-radius: 0px 0px 15px 15px;">
              <v-card-title
                class="white--text pb-1">
                #{{ detail_pos.delivery_kode }}
              </v-card-title>

              <v-card-text
                class="white--text line-text-second pb-1">
                <v-divider
                  class="mb-3"
                  style="border: 2px solid #fff; border-radius: 50px;" />

                <div>
                  <div>
                    Penerima: {{ detail_pos.delivery_receiver.name }}
                  </div>

                  <div>
                    Telepon: {{ detail_pos.delivery_receiver.phone }}
                  </div>

                  <div
                    class="font-weight-bold mt-3">
                    Lokasi Pengiriman:
                  </div>

                  <div>
                    Alamat: {{ detail_pos.delivery_receiver.address }}
                  </div>

                  <div>
                    Provinsi: {{ detail_pos.delivery_receiver.province }}
                  </div>

                  <div>
                    Kabupaten: {{ detail_pos.delivery_receiver.city }}
                  </div>

                  <div>
                    Kecamatan: {{ detail_pos.delivery_receiver.subdistrict }}
                  </div>

                  <div>
                    Kelurahan: {{ detail_pos.delivery_receiver.village }}
                  </div>

                  <div>
                    Kode POS: {{ detail_pos.delivery_receiver.zipcode }}
                  </div>


                  <div
                    class="mt-3">
                    Resi: {{ detail_pos.delivery_resi !== '' ? detail_pos.delivery_resi : '-' }}
                  </div>
                </div>

                <v-divider
                  class="my-3"
                  style="border: 2px solid #fff; border-radius: 50px;" />

                <div>
                  <div
                    class="caption font-weight-bold d-flex align-center mt-4">
                    <div
                      class="d-flex align-center">
                      <v-icon small color="white" class="mr-1">mdi-calendar-month</v-icon>

                      {{ detail_pos.delivery_create_datetime | date }}
                    </div>

                    <v-spacer />

                    <div
                      class="d-flex align-center">
                      <v-icon small color="white" class="mr-1">mdi-clock-time-three-outline</v-icon>

                      {{ detail_pos.delivery_create_datetime | time }}
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>

            <v-card-text
              class="py-0 pl-0">
              <v-timeline
                align-center
                dense>
                <v-skeleton-loader
                  v-for="(item, index) in process.log ? 7 : log_pos"
                  :key="index"
                  :loading="process.log"
                  type="list-item-avatar-three-line">
                  <div>
                    <div v-if="!process.load && log_pos.length > 0">
                      <v-timeline-item
                        :color="item.color"
                        small>
                        <v-row
                          @click="selected.detail = item; sheet.detail = true;"
                          class="cursor-pointer">
                          <v-col
                            cols="3">
                            <strong
                              class="black--text"
                              style="opacity: 60%;">
                              {{ item.created_at | time }}
                            </strong>
                          </v-col>

                          <v-col>
                            <strong
                              :style="`color: ${item.color};`">
                              {{ item.status }}
                            </strong>

                            <div
                              class="caption font-weight-light five-line line-text-second">
                              <span
                                v-html="item.msg">
                              </span>
                            </div>

                            <div
                              class="caption font-weight-bold black--text"
                              style="opacity: 60%;">
                              {{ item.created_at | date }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-timeline-item>
                    </div>
                  </div>
                </v-skeleton-loader>
              </v-timeline>
             </v-card-text>
          </v-card>
        </v-bottom-sheet>

        <!-- DETAIL LOG -->
        <v-bottom-sheet
          v-model="sheet.detail"
          hide-overlay
          persistent
          fullscreen
          scrollable>
          <v-card
            flat
            style="border-radius: 0px;">
            <v-card-title
              @click="sheet.detail = false"
              class="cursor-pointer pa-4"
              style="border-radius: 0px 0px 15px 15px;
                    position: absolute;
                    width: 100%;
                    z-index: 1;
                    background: #7c0404;">
              <v-icon color="white">
                mdi-arrow-left-thick
              </v-icon>

              <span
                class="body-1 font-weight-bold text-capitalize white--text ml-1">
                Detail Ajuan Pengiriman
              </span>
            </v-card-title>

            <v-card-text v-if="Object.keys(selected.detail).length > 0"
              class="body-2 font-weight-light text-first line-text-second mt-16">
              <div
                class="title black--text font-weight-bold mt-2">
                #{{ selected.detail.no_reg }}
              </div>

              <div
                class="mb-2">
                <span
                  :style="`color: ${selected.detail.status};`">
                  {{ selected.detail.status }}
                </span>
              </div>

              <div v-if="selected.detail.status === 'DITOLAK'"
                class="pa-2 px-3 red--text log_note"
                style="border: 1px solid #fff;
                      border-radius: 7px;
                      border-style: dashed;
                      background: #ff000033;">
                <span
                  v-html="selected.detail.msg">
                </span>
              </div>

              <div
                class="my-3"
                style="opacity: 60%;">
                Tanggal <b>{{ selected.detail.created_at | date }}</b> Pukul <b>{{ selected.detail.created_at | time }}</b>
              </div>

              <div v-if="detail_pos.delivery_receiver.images.length > 0"
                class="font-weight-bold black--text">
                Data Dukung:
              </div>

              <v-row>
                <v-col
                  v-for="(item, index) in detail_pos.delivery_receiver.images"
                  :key="index"
                  cols="6">
                  <v-img
                    width="100%"
                    height="125"
                    alt="vuetify"
                    gradient="to bottom, rgba(0, 0, 0, .1), rgba(0, 0, 0, .5)"
                    :src="item.url"
                    style="border-radius: 10px;">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular
                          indeterminate
                          color="#7c0404">
                        </v-progress-circular>
                      </v-row>
                    </template>

                    <a
                      :href="item.url"
                      target="_blank">
                      <v-icon
                        class="cursor-pointer pa-2"
                        size="20"
                        color="white"
                        style="position: absolute;
                              top: 0px;
                              right: 25px;">
                        mdi-download
                      </v-icon>
                    </a>

                    <v-icon
                      @click="sheet.zoom = true; selected.title = 'Data Dukung Penngiriman'; selected.zoom = item.url;"
                      class="cursor-pointer pa-2"
                      size="20"
                      color="white"
                      style="position: absolute;
                            top: 0px;
                            right: 0px;">
                      mdi-fullscreen
                    </v-icon>
                  </v-img>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions v-if="selected.detail.status === 'DITOLAK'"
              class="mb-3 pt-0">
              <v-btn
                @click="sheet.koreksi = true; reset_koreksi();"
                block
                elevation="0"
                color="orange"
                class="body-2 font-weight-bold white--text text-capitalize d-flex align-center"
                style="border-radius: 10px;">
                <v-icon size="20">mdi-text-box-edit-outline</v-icon>

                <v-spacer />

                <span
                  class="ml-1">
                  Koreksi Data Sekarang ?
                </span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-bottom-sheet>

        <!-- ZOOM -->
        <v-bottom-sheet
          v-model="sheet.zoom"
          hide-overlay
          persistent
          fullscreen
          scrollable>
          <v-card
            flat
            style="border-radius: 0px;">
            <v-card-title
              @click="sheet.zoom = false"
              class="cursor-pointer pa-4"
              style="border-radius: 0px 0px 15px 15px;
                    position: absolute;
                    width: 100%;
                    z-index: 1;
                    background: #7c0404;">
              <div
                class="d-flex align-center">
                <v-icon color="white">
                  mdi-arrow-left-thick
                </v-icon>

                <span
                  class="body-1 font-weight-bold text-capitalize white--text ml-1">
                  <span class="one-line">
                    Data Dukung Pengiriman
                  </span>
                </span>
              </div>
            </v-card-title>

            <v-card-text
              class="pt-16 mt-4 pa-4">
              <v-card
                flat
                style="border-radius: 10px;">
                <v-img
                  contain
                  alt="vuetify"
                  :src="selected.zoom">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center">
                      <v-progress-circular
                        indeterminate
                        color="#7c0404">
                      </v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-card>
            </v-card-text>
          </v-card>
        </v-bottom-sheet>

        <!-- KOREKSI -->
        <v-bottom-sheet
          v-model="sheet.koreksi"
          hide-overlay
          persistent
          fullscreen
          scrollable>
          <v-card
            flat
            style="border-radius: 0px;">
            <v-card-title
              @click="sheet.koreksi = false"
              class="cursor-pointer pa-4"
              style="border-radius: 0px 0px 15px 15px;
                    position: absolute;
                    width: 100%;
                    z-index: 1;
                    background: #7c0404;">
              <v-icon color="white">
                mdi-arrow-left-thick
              </v-icon>

              <span
                class="body-1 font-weight-bold text-capitalize white--text ml-1">
                Koreksi Data Pengiriman POS
              </span>
            </v-card-title>

            <v-card v-if="Object.keys(detail_pos).length > 0"
              flat
              color="#7c0404"
              class="pt-12 pb-4"
              style="border-radius: 0px 0px 15px 15px;">
              <v-card-title
                class="white--text pb-1">
                #{{ detail_pos.delivery_kode }}
              </v-card-title>

              <v-card-text
                class="white--text line-text-second pb-1">
                <v-divider
                  class="mb-3"
                  style="border: 2px solid #fff; border-radius: 50px;" />

                <div>
                  <div>
                    Penerima: {{ detail_pos.delivery_receiver.name }}
                  </div>

                  <div>
                    Telepon: {{ detail_pos.delivery_receiver.phone }}
                  </div>

                  <div
                    class="font-weight-bold mt-3">
                    Alamat:
                  </div>

                  <div>
                    Provinsi: {{ detail_pos.delivery_receiver.province }}
                  </div>

                  <div>
                    Kabupaten: {{ detail_pos.delivery_receiver.city }}
                  </div>

                  <div>
                    Kecamatan: {{ detail_pos.delivery_receiver.subdistrict }}
                  </div>

                  <div>
                    Kelurahan: {{ detail_pos.delivery_receiver.village }}
                  </div>

                  <div>
                    Kode POS: {{ detail_pos.delivery_receiver.zipcode }}
                  </div>
                </div>

                <v-divider
                  class="my-3"
                  style="border: 2px solid #fff; border-radius: 50px;" />

                <div>
                  <div
                    class="caption font-weight-bold d-flex align-center mt-4">
                    <div
                      class="d-flex align-center">
                      <v-icon small color="white" class="mr-1">mdi-calendar-month</v-icon>

                      {{ detail_pos.delivery_create_datetime | date }}
                    </div>

                    <v-spacer />

                    <div
                      class="d-flex align-center">
                      <v-icon small color="white" class="mr-1">mdi-clock-time-three-outline</v-icon>

                      {{ detail_pos.delivery_create_datetime | time }}
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>

            <v-card-text
              class="pt-6 pb-2">
              <ValidationObserver
                ref="form">
                <v-form>
                  <div>
                    <div
                      class="font-weight-bold black--text">
                      Kontak & Alamat Pengiriman
                    </div>

                    <div
                      class="mb-4">
                      Sesuaikan kontak & alamat pengiriman di bawah ini :
                    </div>
                  </div>

                  <ValidationProvider
                    name="name"
                    rules="required"
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Nama Penerima
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>

                    <v-text-field
                      filled
                      rounded
                      dense
                      color="#7c0404"
                      placeholder="Contoh. Firmansyah Abdul Rafi"
                      :append-icon="valid ? 'mdi-check-circle-outline' : ''"
                      v-model="form.receiver.name"
                      v-uppercase
                      :success="valid"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider
                    name="phone"
                    rules="required|min:8|max:13"
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Telepon
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>

                    <v-text-field
                      v-on:keyup.enter="save"
                      type="number"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      min="0"
                      filled
                      rounded
                      dense
                      color="#7c0404"
                      placeholder="Contoh. 081332XXXXXX"
                      :append-icon="valid ? 'mdi-check-circle-outline' : ''"
                      v-model="form.receiver.phone"
                      v-uppercase
                      :success="valid"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider
                    name="email"
                    rules="required|email"
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Email
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>

                    <v-text-field
                      v-on:keyup.enter="save"
                      filled
                      rounded
                      dense
                      color="#7c0404"
                      placeholder="Contoh. XXXXX@gmail.com"
                      :append-icon="valid ? 'mdi-check-circle-outline' : ''"
                      v-model="form.receiver.email"
                      :success="valid"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider
                    name="address"
                    rules="required"
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Alamat
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>

                    <v-text-field
                      filled
                      rounded
                      dense
                      color="#7c0404"
                      placeholder="Contoh. Kemiri"
                      :append-icon="valid ? 'mdi-check-circle-outline' : ''"
                      v-model="form.receiver.address"
                      v-uppercase
                      :success="valid"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider
                    name="Provinsi"
                    rules="required"
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Provinsi
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>

                    <v-autocomplete
                      filled
                      rounded
                      dense
                      color="#7c0404"
                      placeholder="Contoh. Jawa tengah"
                      :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                      :items="config.province_pos"
                      item-value="provinceCode"
                      item-text="provinceName"
                      item-color="#7c0404"

                      v-model="form.receiver.provinceCode"
                      :success="valid"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                    </v-autocomplete>
                  </ValidationProvider>

                  <ValidationProvider
                    name="Kabupaten"
                    rules="required"
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Kabupaten
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>

                    <v-autocomplete
                      filled
                      rounded
                      dense
                      color="#7c0404"
                      placeholder="Contoh. Sukoharjo"
                      :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                      :items="config.city_pos"
                      item-value="cityCode"
                      item-text="cityName"
                      item-color="#7c0404"

                      v-model="form.receiver.cityCode"
                      :success="valid"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                    </v-autocomplete>
                  </ValidationProvider>

                  <ValidationProvider
                    name="Kecamatan"
                    rules="required"
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Kecamatan
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>

                    <v-autocomplete
                      filled
                      rounded
                      dense
                      color="#7c0404"
                      placeholder="Contoh. Trucuk"
                      :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                      :items="config.subdistrict_pos"
                      item-value="subDistrictCode"
                      item-text="subDistrictName"
                      item-color="#7c0404"

                      v-model="form.receiver.subDistrictCode"
                      :success="valid"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                    </v-autocomplete>
                  </ValidationProvider>

                  <ValidationProvider
                    name="zipcode"
                    rules="required"
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Kode Pos
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>

                    <v-autocomplete
                      filled
                      rounded
                      dense
                      color="#7c0404"
                      placeholder="Contoh. Kradenan (57467)"
                      :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                      :items="config.postal_code"
                      item-value="postalCode"
                      item-text="titlePostalCode"
                      item-color="#7c0404"

                      v-model="form.receiver.zipcode"
                      :success="valid"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                    </v-autocomplete>
                  </ValidationProvider>

                  <div>
                    <div
                      class="font-weight-bold black--text">
                      Upload Data Dukung Pengiriman
                    </div>

                    <div>
                      Jika pengajuan pergantian ktp silahkan upload foto ktp yang sudah di potong dan di lipat seperti contoh di bawah ini :
                    </div>
                  </div>

                  <v-row>
                    <v-col
                      cols="12"
                      md="6">
                      <v-img
                        contain
                        alt="kominfo"
                        :src="require('@/assets/image/KTP_POTONG.jpeg')"
                        style="border-radius: 10px;">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular
                              indeterminate
                              color="#7c0404">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-col>
                  </v-row>

                  <v-card
                    flat
                    color="white"
                    style="box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px; border-radius: 10px;">
                    <v-card-title
                      class="body-2 pb-2">
                      <span style="opacity: 60%;">
                        Upload Data Dukung
                      </span>
                    </v-card-title>

                    <v-divider
                      style="border: 2px solid #f9f9f9; border-radius: 50px;" />

                    <v-card-text
                      class="py-4 px-0">
                      <v-row>
                        <v-col
                          v-for="(item_img, index_img) in form.receiver.images"
                          :key="index_img"
                          cols="6"
                          md="4">
                          <v-card
                            flat
                            height="136"
                            class="d-flex align-center justify-center"
                            style="border-radius: 15px;
                                  border: 2px solid #eaeaea;
                                  border-style: dashed;
                                  box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px; ">
                            <v-img
                              alt="kominfo"
                              width="100%"
                              height="136"
                              :src="item_img.url"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular
                                    indeterminate
                                    color="#7c0404">
                                  </v-progress-circular>
                                </v-row>
                              </template>

                              <div @click="form.receiver.images.splice(index_img, 1)"
                                class="cursor-pointer"
                                style="position: absolute; top: 5px; right: 5px;">
                                <v-icon size="20" color="red">mdi-close-circle</v-icon>
                              </div>
                            </v-img>
                          </v-card>
                        </v-col>

                        <v-col
                          cols="6"
                          md="4">
                          <v-card @click="sheet.option = true"
                            flat
                            height="136"
                            class="d-flex align-center justify-center"
                            style="border-radius: 15px;
                                  border: 2px solid #eaeaea;
                                  border-style: dashed;">
                            <v-icon v-if="!process.file"
                              size="50"
                              color="grey">
                              mdi-cloud-upload-outline
                            </v-icon>

                            <v-progress-circular v-if="process.file"
                              indeterminate
                              color="#7c0404">
                            </v-progress-circular>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center my-3">
                <v-alert
                  type="error"
                  text
                  dense
                  prominent
                  v-show="message.error.length > 0">
                  {{ message.error }}
                </v-alert>
              </div>
            </v-card-text>

            <v-card-actions
              class="mb-3 pt-0">
              <v-btn
                @click="save_koreksi()"
                :loading="process.form"
                :disabled="process.form"

                block
                elevation="0"
                color="orange"
                class="body-2 font-weight-bold white--text text-capitalize d-flex align-center"
                style="border-radius: 10px;">
                <v-icon size="20">mdi-truck-check</v-icon>

                <v-spacer />

                <span
                  class="ml-1">
                  Koreksi Pengiriman
                </span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-bottom-sheet>

        <v-bottom-sheet
          v-model="sheet.option"
          hide-overlay>
          <v-card
            flat
            color="#fff"
            class="d-flex align-center"
            style="border-radius: 30px 30px 0px 0px;">
            <v-card-text
              class="pa-3">
              <v-row
                align="center"
                justify="center">
                <!-- CAMERA -->
                <v-col cols="4" class="text-center">
                  <div @click="sheet.upload = true; selected.type = 'camera';"
                    class="cursor-pointer">
                    <v-avatar
                      size="50"
                      class="cursor-pointer"
                      v-ripple
                      style="box-shadow: rgba(0, 0, 0, 0.45) 0px 25px 20px -20px;">
                      <v-img
                        alt="kominfo"
                        :src="require('@/assets/image/camera.png')"
                        class="ma-auto">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular
                              indeterminate
                              color="#7c0404">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <div class="font-weight-bold black--text mt-2">
                      Kamera
                    </div>
                  </div>
                </v-col>

                <v-col cols="4" class="text-center px-0">
                  <div class="d-flex align-center">
                    <v-divider style="border: 2px solid #eaeaea; border-radius: 50px;" />
                    <div class="mx-2">
                      Atau
                    </div>
                    <v-divider style="border: 2px solid #eaeaea; border-radius: 50px;" />
                  </div>
                </v-col>

                <!-- FOLDER -->
                <v-col
                  cols="4"
                  class="text-center">
                  <upload-folder
                    v-model="upload.folder">
                    <div slot="activator">
                      <v-avatar
                        size="50"
                        class="cursor-pointer"
                        v-ripple
                        style="box-shadow: rgba(0, 0, 0, 0.45) 0px 25px 20px -20px;">
                        <v-img
                          alt="kominfo"
                          :src="require('@/assets/image/folder.png')"
                          class="ma-auto">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular
                                indeterminate
                                color="#7c0404">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-avatar>

                      <div class="font-weight-bold black--text mt-2">
                        Galeri
                      </div>
                    </div>
                  </upload-folder>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-bottom-sheet>

        <v-bottom-sheet
          v-model="sheet.upload"
          hide-overlay
          persistent>
          <upload-camera
            v-if="selected.type === 'camera'"
            :sheet="sheet.upload"
            @frame="sheet.upload = $event"
            @input="addCamera($event)"
            @close="sheet.upload = $event; selected.type = '';" />
        </v-bottom-sheet>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  export default {
    props: {
      detail: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        dialog: {
          success: false,
          success_koreksi: false
        },

        sheet: {
          pos: false,
          log: false,

          option: false,
          upload: false,

          detail: false,
          zoom: false,

          koreksi: false
        },

        selected: {
          type: '',

          detail: {},

          title: '',
          zoom: ''
        },

        detail_pos: {},
        log_pos: [],

        list: [],
        pagination: {},

        limit: 10,

        config: {
          province_pos: [],
          city_pos: [],
          subdistrict_pos: [],
          postal_code: []
        },

        form: {
          ajuan_no_reg:[],
          receiver: {
            name: '',
            phone: '',
            email: '',
            address: '',

            province: '',
            city: '',
            subdistrict: '',
            village: '',

            provinceCode: '',
            provinceName: '',

            cityCode: '',
            cityName: '',

            subDistrictCode: '',
            subSubDistrictName: '',

            villageCode: '',
            villageName: '',

            zipcode: '',
            geolang: '',
            geolat: '',

            images: []
          },
          service: {
            serviceCode: 0,
            fee: 0,
            feeTax: 0,
            insurance: 0,
            insuranceTax: 0,

            itemValue: 0,
            totalFee: 0
          }
        },

        upload: {
          camera: null,
          folder: null
        },

        process: {
          load: false,

          form: false,

          province_pos: false,
          city_pos: false,
          subdistrict_pos: false,
          postal_code: false,
          get_fee: false,

          pos: false,
          log: false,

          file: false
        },

        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      Empty: () => import(/* webpackPrefetch: true */ '@/components/Empty'),
      UploadCamera: () => import(/* webpackPrefetch: true */ '@/components/upload/camera.vue'),
      UploadFolder: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'limit': function() {
        this.fetch()
      },

      'form.receiver.provinceCode': function() {
        let t = this
        let prov = this.config.province_pos.filter(function(v) {
          return t.form.receiver.provinceCode == v.provinceCode
        })

        if (prov.length > 0) {
          this.form.receiver.province = prov[0].provinceName

          this.form.receiver.provinceName = prov[0].provinceName
        }

        this.static().city_pos()
      },

      'form.receiver.cityCode': function() {
        let t = this
        let kot = this.config.city_pos.filter(function(v) {
          return t.form.receiver.cityCode == v.cityCode
        })

        if (kot.length > 0) {
          this.form.receiver.city = kot[0].cityName

          this.form.receiver.cityName = kot[0].cityName
        }

        this.static().subdistrict_pos()
      },

      'form.receiver.subDistrictCode': function() {
        let t = this
        let kec = this.config.subdistrict_pos.filter(function(v) {
          return t.form.receiver.subDistrictCode == v.subDistrictCode
        })

        if (kec.length > 0) {
          this.form.receiver.subdistrict = kec[0].subDistrictName

          this.form.receiver.subSubDistrictName = kec[0].subDistrictName
        }

        this.static().postal_code()
      },

      'form.receiver.zipcode': function() {
        let t = this
        let kel = this.config.postal_code.filter(function(v) {
          return t.form.receiver.zipcode == v.postalCode
        })

        if (kel.length > 0) {
          this.form.receiver.village = kel[0].subSubDistrictName

          this.form.receiver.villageCode = kel[0].subSubDistrictCode
          this.form.receiver.villageName = kel[0].subSubDistrictName
        }

        this.static().get_fee()
      },

      'upload.folder': {
        handler: function () {
          if (this.upload.folder) {
            this.process.file = this.upload.folder.process

            if (!this.process.file) {
              // CALLBACK FROM UPLOAD IMAGE
              this.sheet.option = false

              this.form.receiver.images.push({
                url: this.upload.folder.data.full.file_url,
                type: this.upload.folder.type,
                process: this.upload.folder.process,
                user_id: this.user.id,
                file_id: this.upload.folder.id === undefined ? 0 : this.upload.folder.id
              })
            }
          }
        },
        deep: true
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      user() {
        return this.$store.state.member.auth.user
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      fetch () {
        this.fetchProduct()

        this.fetchPOS()
      },

      async fetchProduct () {
        this.process.load = true

        let params = {
          limit: this.limit,
          prod_ajuan_id: this.detail.ajuan_id,
          order_by: 'ASC'
        }

        await this.$axios.$get(`${process.env.PREFIX_PROXY}/produk/list`, { params })
        .then((response) => {
          if (response.code === 200) {
            this.process.load = false

            this.list = response.data
            this.pagination = response.pagination
          }
        })
      },

      reset () {
        if (this.$refs.form) this.$refs.form.reset()

        let self = this

        navigator.permissions.query({ name: 'geolocation' })
        .then(function(result) {
          if (result.state !== 'denied') {
            navigator.geolocation.getCurrentPosition(position => {
              self.form = {
                ajuan_no_reg: self.detail.ajuan_no_reg,
                receiver: {
                  name: self.user.fullname,
                  phone: self.user.phone,
                  email: self.user.email,
                  address: self.user.dukuh,

                  province: '',
                  city: '',
                  subdistrict: '',
                  village: '',

                  provinceCode: '',
                  provinceName: '',

                  cityCode: '',
                  cityName: '',

                  subDistrictCode: '',
                  subSubDistrictName: '',

                  villageCode: '',
                  villageName: '',

                  zipcode: '',
                  geolang: position.coords.latitude,
                  geolat: position.coords.longitude,

                  images: []
                },
                service: {
                  serviceCode: 0,
                  fee: 0,
                  feeTax: 0,
                  insurance: 0,
                  insuranceTax: 0,

                  itemValue: 0,
                  totalFee: 0
                }
              }

              self.static().province_pos()
            })
          } else {
            // JIKA DENIED
          }
        })

        this.process.form = false

        this.message.error = ''
      },

      reset_koreksi () {
        if (this.$refs.form) this.$refs.form.reset()

        let self = this

        navigator.permissions.query({ name: 'geolocation' })
        .then(function(result) {
          if (result.state !== 'denied') {
            navigator.geolocation.getCurrentPosition(position => {
              self.form = {
                ajuan_no_reg: self.detail.ajuan_no_reg,
                receiver: self.detail_pos.delivery_receiver,
                service: self.detail_pos.delivery_service
              }

              self.static().province_pos()
            })
          } else {
            // JIKA DENIED
          }
        })

        this.process.form = false

        this.message.error = ''
      },

      static () {
        let t = this
        return {
          async province_pos () {
            t.process.province_pos = true

            await t.$axios.$post(`${process.env.PREFIX_PROXY}/delivery/getProvince`)
            .then(response => {
              if (response.code == 200) {
                t.process.province_pos = false

                t.config.province_pos = response.data
              }
            })
          },

          async city_pos () {
            t.process.city_pos = true

            await t.$axios.$post(`${process.env.PREFIX_PROXY}/delivery/getCity`, {
              provinceCode: t.form.receiver.provinceCode,
              cityName: 'Sukoharjo'
            })
            .then(response => {
              if (response.code == 200) {
                t.process.city_pos = false

                t.config.city_pos = response.data
              }
            })
          },

          async subdistrict_pos () {
            t.process.subdistrict_pos = true

            await t.$axios.$post(`${process.env.PREFIX_PROXY}/delivery/getSubDistrict`, {
              provinceCode: t.form.receiver.provinceCode,
              cityCode: t.form.receiver.cityCode,
              subDistrictName: 'Sukoharjo'
            })
            .then(response => {
              if (response.code == 200) {
                t.process.subdistrict_pos = false

                t.config.subdistrict_pos = response.data
              }
            })
          },

          async postal_code () {
            t.process.postal_code = true

            t.config.postal_code = []

            await t.$axios.$post(`${process.env.PREFIX_PROXY}/delivery/getSubSubDistrict`, {
              provinceCode: t.form.receiver.provinceCode,
              cityCode: t.form.receiver.cityCode,
              subDistrictCode: t.form.receiver.subDistrictCode,
              subSubDistrictName: t.form.receiver.subSubDistrictName
            })
            .then(response => {
              if (response.code == 200) {
                t.process.postal_code = false

                response.data.forEach(obj => {
                  t.config.postal_code.push({
                    subSubDistrictCode: obj.subSubDistrictCode,
                    subSubDistrictName: obj.subSubDistrictName,
                    postalCode: obj.postalCode,

                    titlePostalCode: `${obj.subSubDistrictName} (${obj.postalCode})`
                  })
                })
              }
            })
          },

          async get_fee () {
            t.process.get_fee = true

            await t.$axios.$post(`${process.env.PREFIX_PROXY}/delivery/getFee`, {
              receiverzipcode: t.form.receiver.zipcode
            })
            .then(response => {
              if (response.code == 200) {
                t.process.get_fee = false

                if (response.data.length > 0) {
                  t.form.service = {
                    serviceCode: response.data[0].serviceCode,
                    fee: Number(response.data[0].fee),
                    feeTax: Number(response.data[0].feeTax),
                    insurance: Number(response.data[0].insurance),
                    insuranceTax: Number(response.data[0].insuranceTax),

                    itemValue: Number(response.data[0].itemValue),
                    totalFee: Number(response.data[0].totalFee)
                  }
                }
              }
            })
          }
        }
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await this.$axios.$post(`${process.env.PREFIX_PROXY}/delivery/requestPengiriman`, this.form)
          .then((response) => {

            this.process.form = false

            if (response.code === 200) {
              this.dialog.success = true
            } else {
              this.message.error = response.message
            }

          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      async save_koreksi () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await this.$axios.$post(`${process.env.PREFIX_PROXY}/delivery/requestPengirimanUpdate`, this.form)
          .then((response) => {

            this.process.form = false

            if (response.code === 200) {
              this.dialog.success_koreksi = true
            } else {
              this.message.error = response.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      async fetchPOS () {
        this.process.pos = true

        let params = {
          ajuan_no_reg: this.detail.ajuan_no_reg
        }

        await this.$axios.$get(`${process.env.PREFIX_PROXY}/delivery/detail`, { params })
        .then((response) => {
          this.process.pos = false

          if (response.code === 200) {
            if (Object.keys(response.data).length > 0) {
              this.detail_pos = response.data
            }
          } else {
            this.detail_pos = {}
          }
        })
      },

      async fetchLogPOS () {
        this.process.log = true

        let params = {
          ajuan_no_reg: this.detail.ajuan_no_reg
        }

        this.log_pos = []

        await this.$axios.$get(`${process.env.PREFIX_PROXY}/delivery/log`, { params })
        .then((response) => {
          // this.process.log = false

          if (response.code === 200) {
            // this.log_pos = response.data

            let data = response.data

            data.forEach(obj => {
              this.log_pos.push({
                no_reg: obj.no_reg,
                status: obj.status,
                msg: obj.status !== 'DITOLAK' ? obj.msg : obj.note,
                created_at: obj.created_at,
                color: obj.status === 'REQUEST' ? '#FF9800' :
                       obj.status === 'DIKOREKSI' ? '#CDDC39' :
                       obj.status === 'DIPROSES' ? '#2196F3' :
                       obj.status === 'DISORTIR' ? '#4CAF50' :
                       obj.status === 'DITOLAK' ? '#F44336' : '#009688'
              })
            })

            if(Object.keys(this.detail_pos).length > 0 && this.detail_pos.delivery_resi !== '' && this.log_pos[0].status === 'DISORTIR') {
              this.fetchTrack()
            } else {
              this.process.log = false
            }
          }
        })
      },

      addCamera (e) {
        this.sheet.option = false

        this.process.file = e.process

        if (!e.process) {
          this.form.receiver.images.push({
            url: e.data.full.file_url,
            type: e.data.type,
            process: e.data.process,
            user_id: this.user.id,
            file_id: e.data.id === undefined ? 0 : e.data.id
          })

          this.selected.type = ''
        }
      },

      async fetchTrack () {
        let array_track = []

        await this.$axios.$post(`${process.env.PREFIX_PROXY}/delivery/getTrackAndTrace`, {
          resi: this.detail_pos.delivery_resi
         })
        .then((response) => {
          this.process.log = false

          if (response.code === 200) {
            let data = response.data

            data.forEach(obj => {
              array_track.push({
                no_reg: this.log_pos[0].no_reg,
                status: obj.eventName,
                msg: obj.description,
                created_at: obj.eventDate,
                color: obj.eventName.includes('POSTING LOKET') ? '#9C27B0' :
                       obj.eventName.includes('MANIFEST SERAH') ? '#673AB7' :
                       obj.eventName.includes('MANIFEST TERIMA') ? '#03A9F4' :
                       obj.eventName.includes('PROSES ANTAR') ? '#3F51B5' : '#009688'
              })
            })

            array_track = array_track.toReversed()

            this.log_pos = [...array_track, ...this.log_pos]
          }
        })
      }
    }
  }
</script>

<style scoped>
  .v-application--is-ltr .v-timeline--dense:not(.v-timeline--reverse):before {
    min-height: calc(100vh - 249px);
  }
</style>
